import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  UserIcon,
  PhoneIcon,
  EnvelopeIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import "./GetACall.css";
import axios from "axios";
import toast from "react-hot-toast";

const GetACall = ({ showModal, setShowModal }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    description: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    try {
      const response = await axios.post(
        "https://api.krinvy.com/api/postrequestform",
        formData
      );
      if (response.data.success) {
        toast.success(response.data.message);
        setShowModal(false);
        setFormData({
          name: "",
          email: "",
          phone: "",
          description: "",
        });
      }
    } catch (error) {
       if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <AnimatePresence>
      {showModal && (
        <div className="gac-modal-overlay gac-active">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="gac-modal-container"
          >
            <div className="gac-modal-content-wrapper">
              {/* Left Side - Content */}
              <div className="gac-modal-content-left">
                <h2>Need immediate assistance?</h2>
                <p>
                  Our team is ready to call you back at your preferred time to
                  discuss your needs.
                </p>
              </div>

              {/* Right Side - Form */}
              <div className="gac-modal-content-right">
                <div className="gac-modal-header">
                  <div className="gac-modal-header-content">
                    <h3 className="gac-modal-title">Request a Call Back</h3>
                    <button
                      className="gac-modal-close-btn"
                      onClick={() => setShowModal(false)}
                    >
                      <XMarkIcon className="gac-close-icon" />
                    </button>
                  </div>
                </div>

                <div className="gac-modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="gac-form-group">
                      <label className="gac-form-label">Full Name</label>
                      <div className="gac-input-with-icon">
                        <UserIcon className="gac-input-icon" />
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="gac-form-control"
                          required
                          placeholder="Your name"
                        />
                      </div>
                    </div>

                    <div className="gac-form-group">
                      <label className="gac-form-label">Email</label>
                      <div className="gac-input-with-icon">
                        <EnvelopeIcon className="gac-input-icon" />
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="gac-form-control"
                          required
                          placeholder="Your email"
                        />
                      </div>
                    </div>

                    <div className="gac-form-group">
                      <label className="gac-form-label">Phone Number</label>
                      <div className="gac-input-with-icon">
                        <PhoneIcon className="gac-input-icon" />
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          className="gac-form-control"
                          required
                          placeholder="Your phone number"
                        />
                      </div>
                    </div>

                    <div className="gac-form-group">
                      <label className="gac-form-label">Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        rows={4}
                        className="gac-form-control"
                        placeholder="How can we help you?"
                      />
                    </div>

                    <div className="gac-form-actions">
                      <button type="submit" className="gac-btn gac-btn-primary">
                        Submit Request
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default GetACall;
